import BaseTableCell from '@tiptap/extension-table-cell'
import BaseTableHeader from '@tiptap/extension-table-header'

const TABLE_CELL_CONTENT = '(paragraph|heading|bulletList|orderedList)+'

export const NonNestedTableCell = BaseTableCell.extend({
    content: TABLE_CELL_CONTENT
})

export const NonNestedTableHeader = BaseTableHeader.extend({
    content: TABLE_CELL_CONTENT
})
